import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import SVG from 'react-inlinesvg'
import Markdown from '../../parts/markdown'

import user from '@base/assets/icons/user.svg'
import chevron from '@base/assets/icons/chevron.svg'
import check from '@base/assets/icons/check.svg'
import bhvr from '@base/assets/icons/logos/bhvr.svg'

// DESKTOP IMAGE
import dbdImg from '@base/assets/img/main-nav/dbd.jpg'
import tcofsImg from '@base/assets/img/main-nav/tcofs.jpg'
import projecttImg from '@base/assets/img/main-nav/project-t.jpg'
import wtfImg from '@base/assets/img/main-nav/wtf.jpg'
import hoyImg from '@base/assets/img/main-nav/hooked-on-you.jpg'

import blightImg from '@base/assets/img/main-nav/blight.jpg'
import mymImg from '@base/assets/img/main-nav/mym.jpg'
import ioiImg from '@base/assets/img/main-nav/ioi.jpg'
import fmImg from '@base/assets/img/main-nav/flipping-misfits.jpg'

// MOBILE IMAGE
import dbdImgMobile from '@base/assets/img/main-nav/mobile/dbd.jpg'
import tcofsImgMobile from '@base/assets/img/main-nav/mobile/tcofs.jpg'
import projecttImgMobile from '@base/assets/img/main-nav/mobile/project-t.jpg'
import wtfImgMobile from '@base/assets/img/main-nav/mobile/wtf.jpg'
import hoyImgMobile from '@base/assets/img/main-nav/mobile/hooked-on-you.jpg'

import blightImgMobile from '@base/assets/img/main-nav/mobile/blight.jpg'
import mymImgMobile from '@base/assets/img/main-nav/mobile/mym.jpg'
import ioiImgMobile from '@base/assets/img/main-nav/mobile/ioi.jpg'
import fmImgMobile from '@base/assets/img/main-nav/mobile/flipping-misfits.jpg'

const stringsData = require('../../../data/strings.json')

const NavUtilsNew = (props) => {
  const [gamesMenu, setGamesMenu] = useState(false)
  const [defaultGameImage, setDefaultGameImage] = useState(null)
  const [accountMenu, setAccountMenu] = useState(false)
  const locale = props.locale != 'pt-br' ? props.locale : 'pt'
  const project = props.project.toLowerCase()

  const imageRef = useRef(null)
  const expandableDbdRef = useRef(null)
  const expandableOtherRef = useRef(null)

  const menuGames = useRef(null)
  const btnGames = useRef(null)
  const menuAccount = useRef(null)
  const btnAccount = useRef(null)

  const strings = stringsData?.find(x => x.locale === locale)?.nav

  const utmData = {
    dbd: 'deadbydaylight',
    'the casting of frank stone': 'thecastingoffrankstone',
    'project t': 'projectt',
    wtf: 'whatthefog',
    hookedonyou: 'hookedonyou',
    'blight survival': 'blightsurvival',
    mym: 'meetyourmaker',
    ioi: 'islandsofinsight',
    'flippin misfits': 'flippinmisfits'
  }

  const dbdWorldData = [
    {
      project: 'dbd',
      text: 'Dead by daylight',
      image: dbdImg,
      imageMobile: dbdImgMobile,
      en: 'https://deadbydaylight.com/',
      fr: 'https://deadbydaylight.com/fr/',
      ja: 'https://deadbydaylight.com/ja/',
      de: 'https://deadbydaylight.com/de/',
      pt: 'https://deadbydaylight.com/pt-br/',
      es: 'https://deadbydaylight.com/',
    },
    {
      project: 'the casting of frank stone',
      text: 'The Casting of frank stone',
      image: tcofsImg,
      imageMobile: tcofsImgMobile,
      en: 'https://thecastingoffrankstone.com/',
      fr: 'https://thecastingoffrankstone.com/fr/',
      ja: 'https://thecastingoffrankstone.com/ja/',
      de: 'https://thecastingoffrankstone.com/de/',
      pt: 'https://thecastingoffrankstone.com/pt/',
      es: 'https://thecastingoffrankstone.com/es/',
    },
    {
      project: 'project t',
      text: 'Project T',
      image: projecttImg,
      imageMobile: projecttImgMobile,
      en: 'https://insiderprogram.bhvr.com/',
      fr: 'https://insiderprogram.bhvr.com/fr/',
      ja: 'https://insiderprogram.bhvr.com/ja/',
      de: 'https://insiderprogram.bhvr.com/de/',
      pt: 'https://insiderprogram.bhvr.com/pt/',
      es: 'https://insiderprogram.bhvr.com/es/',
    },
    {
      project: 'wtf',
      text: 'What the fog',
      image: wtfImg,
      imageMobile: wtfImgMobile,
      en: 'https://store.steampowered.com/app/2139020/What_the_Fog/',
      fr: 'https://store.steampowered.com/app/2139020/What_the_Fog/',
      ja: 'https://store.steampowered.com/app/2139020/What_the_Fog/',
      de: 'https://store.steampowered.com/app/2139020/What_the_Fog/',
      pt: 'https://store.steampowered.com/app/2139020/What_the_Fog/',
      es: 'https://store.steampowered.com/app/2139020/What_the_Fog/',
    },
    {
      project: 'hookedonyou',
      text: 'Hooked on you',
      image: hoyImg,
      imageMobile: hoyImgMobile,
      en: 'https://hookedonyoudbd.com/',
      fr: 'https://hookedonyoudbd.com/fr/',
      ja: 'https://hookedonyoudbd.com/ja/',
      de: 'https://hookedonyoudbd.com/',
      pt: 'https://hookedonyoudbd.com/',
      es: 'https://hookedonyoudbd.com/',
    },
  ]

  const otherData = [
    {
      project: 'blight survival',
      text: 'Blight survival',
      image: blightImg,
      imageMobile: blightImgMobile,
      en: 'https://blightsurvival.com/',
      fr: 'https://blightsurvival.com/fr/',
      ja: 'https://blightsurvival.com/',
      de: 'https://blightsurvival.com/',
      pt: 'https://blightsurvival.com/',
      es: 'https://blightsurvival.com/',
    },
    {
      project: 'mym',
      text: 'Meet your maker',
      image: mymImg,
      imageMobile: mymImgMobile,
      en: 'https://meetyourmakergame.com/',
      fr: 'https://meetyourmakergame.com/fr/',
      ja: 'https://meetyourmakergame.com/ja/',
      de: 'https://meetyourmakergame.com/de/',
      pt: 'https://meetyourmakergame.com/',
      es: 'https://meetyourmakergame.com/',
    },
    {
      project: 'ioi',
      text: 'Islands of insight',
      image: ioiImg,
      imageMobile: ioiImgMobile,
      en: 'https://www.islandsofinsight.com/',
      fr: 'https://islandsofinsight.com/fr/',
      ja: 'https://www.islandsofinsight.com/',
      de: 'https://www.islandsofinsight.com/',
      pt: 'https://www.islandsofinsight.com/',
      es: 'https://www.islandsofinsight.com/',
    },
    {
      project: 'flippin misfits',
      text: 'Flippin Misfits',
      image: fmImg,
      imageMobile: fmImgMobile,
      en: 'https://flippinmisfits.com/',
      fr: 'https://flippinmisfits.com/fr/',
      ja: 'https://flippinmisfits.com/',
      de: 'https://flippinmisfits.com/',
      pt: 'https://flippinmisfits.com/',
      es: 'https://flippinmisfits.com/',
    },
  ]

  useEffect(() => {
    changeImage(defaultGameImage)
  }, [defaultGameImage])

  const handleOutsideClick = (event) => {
    if (menuAccount.current &&
      menuAccount.current?.className.includes('open') &&
      !menuAccount.current.contains(event.target) &&
      btnAccount.current &&
      !btnAccount.current.contains(event.target)) {
        setAccountMenu(false)
    }

    if (menuGames.current && 
      menuGames.current?.className.includes('open') &&
      !menuGames.current.contains(event.target) &&
      btnGames.current &&
      !btnGames.current.contains(event.target)) {
        setGamesMenu(false)
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const changeImage = (newImage) => {
    imageRef.current.src = newImage
  }

  const resetImage = () => {
    imageRef.current.src = defaultGameImage
  }

  const setupInitalImage = () => {
    let data = dbdWorldData.find((e) => e.project === project)
    if (!data) {
      data = otherData.find((e) => e.project === project)
    }

    const defaultImage = data?.image ? data.image : dbdImg
    setDefaultGameImage(defaultImage)
  }

  const updateSetAccountMenu = () => {
    if (gamesMenu) {
      setGamesMenu(false)
    }
    setAccountMenu(!accountMenu)
  }

  const updateSetGamesMenu = () => {
    if (accountMenu) {
      setAccountMenu(false)
    }
    setGamesMenu(!gamesMenu)
  }

  const toggleExpandable = (ref) => {
    const isOpen = ref.current.classList.value.includes('toggle-open')

    expandableDbdRef.current.classList.remove('toggle-open')
    expandableOtherRef.current.classList.remove('toggle-open')

    if (!isOpen) ref.current.classList.add('toggle-open')
  }

  if (!defaultGameImage) {
    setupInitalImage()
  }

  return (
    <nav
      name="Utilities Navigation"
      className={`${props.className ? props.className : ''} bhvr-main-nav`}
    >
      {/* GAMES PART */}
      <div className="games-part relative mr-auto">
        <motion.button
          initial={{ opacity: 0, filter: 'blur(10px)' }}
          animate={{ opacity: 1, filter: 'blur(0px)' }}
          exit={{ opacity: 0, filter: 'blur(10px)' }}
          transition={{ duration: 0.5, delay: 0.5 }}
          rel="noreferrer"
          ref={btnGames}
          onClick={updateSetGamesMenu}
          className={`
            flex main-nav-button cursor-pointer items-center p-0 border-0 transition-all duration-300
            ${gamesMenu ? 'open' : ''} text-white
          `}
        >
          <SVG
            onError={(error) => console.log(error.message)}
            cacheRequests={true}
            preProcessor={(code) =>
              code.replace(/fill=".*?"/g, 'fill="currentColor"')
            }
            src={bhvr}
            className="block h-auto w-10 lg:w-14 pointer-events-none"
          />

          <div className="btn-text ml-5 flex items-end pointer-events-none">
            <span className="mr-2 text-nav-base font-nav-bold">
              {strings?.games ? strings?.games : 'Games'}
            </span>
            <SVG
              onError={(error) => console.log(error.message)}
              cacheRequests={true}
              preProcessor={(code) =>
                code.replace(/stroke=".*?"/g, 'stroke="currentColor"')
              }
              src={chevron}
              className="chevron mb-2 w-6"
            />
          </div>
        </motion.button>
        <div
          ref={menuGames}
          className={`${
            gamesMenu ? 'open' : ''
          } main-nav-games absolute left-0 top-16 md:top-20 z-40 bg-white px-5 py-10 sm:right-0 lg:px-10`}
        >
          {/* DESKTOP */}
          <div className="main-nav-games-container hidden lg:flex">
            <div className="main-nav-games-content flex pr-10">
              <div className="main-nav-games-content-part w-1/2">
                <h4 className="font-nav-display text-nav-base uppercase pointer-events-none">
                  {strings?.dbdTitle ? strings?.dbdTitle : 'FROM THE WORLD OF DEAD BY DAYLIGHT'}
                </h4>
                {dbdWorldData.map((element, i) => (
                  <a
                    href={`${element[locale] ? element[locale]: element['en']}?utm_source=master-navigation&utm_medium=website&utm_campaign=${utmData[project]}`}
                    target="_blank"
                    onMouseEnter={() => changeImage(element?.image)}
                    onMouseLeave={resetImage}
                    key={`dbd-world-${i}`}
                    className={`main-nav-game-link block rounded uppercase ${
                      project == element.project ? 'actual' : ''
                    }`}
                  >
                    <span className="font-nav-display text-nav-base pointer-events-none">{element.text}</span>
                  </a>
                ))}
              </div>
              <div className="main-nav-games-content-part w-1/2 pl-10">
                <h4 className="font-nav-display text-nav-base uppercase pointer-events-none">
                  {strings?.otherTitle ? strings?.otherTitle : 'OTHER GAMES'}
                </h4>
                {otherData.map((element, i) => (
                  <a
                    href={`${element[locale] ? element[locale]: element['en']}?utm_source=master-navigation&utm_medium=website&utm_campaign=${utmData[project]}`}
                    target="_blank"
                    onMouseEnter={() => changeImage(element?.image)}
                    onMouseLeave={resetImage}
                    key={`other-${i}`}
                    className={`main-nav-game-link block rounded text-base uppercase ${
                      project == element.project ? 'actual' : ''
                    }`}
                  >
                    <span className="font-nav-display text-nav-base pointer-events-none">{element.text}</span>
                  </a>
                ))}
              </div>
            </div>
            <div className="main-nav-games-image w-[60%] overflow-hidden">
              <img src={dbdImg} ref={imageRef} />
            </div>
          </div>

          {/* MOBILE */}
          <div className="main-nav-games-container-mobile flex lg:hidden">
            <div className="main-nav-games-wrapper">
              <div className="main-nav-games-content flex flex-col">
                <div
                  ref={expandableDbdRef}
                  className="main-nav-games-content-part w-full"
                >
                  <button
                    type="button"
                    className="main-nav-toggle-button font-nav-display"
                    onClick={() => toggleExpandable(expandableDbdRef)}
                  >
                    <span className="font-nav-display text-nav-base uppercase pointer-events-none">
                      {strings?.dbdTitle ? strings?.dbdTitle : 'FROM THE WORLD OF DEAD BY DAYLIGHT'}
                    </span>
                    <SVG
                      onError={(error) => console.log(error.message)}
                      cacheRequests={true}
                      preProcessor={(code) =>
                        code.replace(/stroke=".*?"/g, 'stroke="currentColor"')
                      }
                      src={chevron}
                      className="mobile-chevron w-10 pointer-events-none"
                    />
                  </button>
                  <div className="main-nav-expandable expandable-content">
                    {dbdWorldData.map((element, i) => {
                      if (project != element.project)
                        return (
                          <div className="button-visual">
                            <img
                              className="button-visual-img"
                              src={element?.imageMobile}
                            />
                            <a
                              href={`${element[locale] ? element[locale]: element['en']}?utm_source=master-navigation&utm_medium=website&utm_campaign=${utmData[project]}`}
                              target="_blank"
                              key={`dbd-world-mobile-${i}`}
                              className={`button-visual-link block rounded uppercase ${
                                project == element.project ? 'actual' : ''
                              }`}
                            ></a>
                          </div>
                        )
                    })}
                  </div>
                </div>

                <div
                  ref={expandableOtherRef}
                  className="main-nav-games-content-part w-full pt-5"
                >
                  <button
                    type="button"
                    className="main-nav-toggle-button font-nav-display"
                    onClick={() => toggleExpandable(expandableOtherRef)}
                  >
                    <span className="font-nav-display text-nav-base uppercase pointer-events-none">
                      {strings?.otherTitle ? strings?.otherTitle : 'OTHER GAMES'}
                    </span>
                    <SVG
                      onError={(error) => console.log(error.message)}
                      cacheRequests={true}
                      preProcessor={(code) =>
                        code.replace(/stroke=".*?"/g, 'stroke="currentColor"')
                      }
                      src={chevron}
                      className="mobile-chevron w-10 pointer-events-none"
                    />
                  </button>
                  <div className="main-nav-expandable expandable-content">
                    {otherData.map((element, i) => {
                      if (project != element.project)
                        return (
                          <div className="button-visual">
                            <img
                              className="button-visual-img"
                              src={element?.imageMobile}
                            />
                            <a
                              href={`${element[locale] ? element[locale]: element['en']}?utm_source=master-navigation&utm_medium=website&utm_campaign=${utmData[project]}`}
                              target="_blank"
                              key={`other-mobile-${i}`}
                              className={`button-visual-link block rounded font-nav-display uppercase ${
                                project == element.project ? 'actual' : ''
                              }`}
                            ></a>
                          </div>
                        )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ACCOUNT PART */}
      <div className="account-part relative">
        <motion.button
          initial={{ opacity: 0, filter: 'blur(10px)' }}
          animate={{ opacity: 1, filter: 'blur(0px)' }}
          exit={{ opacity: 0, filter: 'blur(10px)' }}
          transition={{ duration: 0.5, delay: 0.5 }}
          rel="noreferrer"
          ref={btnAccount}
          onClick={updateSetAccountMenu}
          className={`
            account-btn flex cursor-pointer items-end border-0 p-0 transition-all duration-300
            ${accountMenu ? 'open' : ''} text-white
          `}
        >
          <SVG
            onError={(error) => console.log(error.message)}
            cacheRequests={true}
            preProcessor={(code) =>
              code.replace(/fill=".*?"/g, 'fill="currentColor"')
            }
            src={user}
            className="mr-1 w-5 lg:mr-2 pointer-events-none"
          />
          <span className="mr-2 text-nav-base font-nav-bold pointer-events-none">
            {strings?.account ? strings?.account : 'Account'}
          </span>
          <SVG
            onError={(error) => console.log(error.message)}
            cacheRequests={true}
            preProcessor={(code) =>
              code.replace(/stroke=".*?"/g, 'stroke="currentColor"')
            }
            src={chevron}
            className="chevron mb-2 w-6 pointer-events-none"
          />
          <span className="sr-only">Behaviour Account</span>
        </motion.button>

        <div
          ref={menuAccount}
          className={`${
            accountMenu ? 'open' : ''
          } main-nav-account absolute -right-5 top-16 md:top-20 z-40 w-screen bg-white p-5 sm:right-0 sm:w-[32rem] lg:w-[55rem] lg:p-10`}
        >
          <div className="main-nav-account-wrapper">
            <div className="main-nav-account-content relative overflow-hidden rounded-lg p-10">
              <div className="main-nav-account-bg absolute left-0 top-0 -z-1 h-full w-full"></div>
              <h3 className="main-nav-account-title text-white text-nav-title font-nav-bold uppercase pointer-events-none">
                <Markdown children={strings?.accountTitle ? strings?.accountTitle : 'CREATE YOUR<br />BEHAVIOUR ACCOUNT NOW'} />
              </h3>
              <div className="spacer mb-10 mt-5 h-[1px] w-full bg-white pointer-events-none"></div>
              <div className="main-nav-account-element mb-4 flex items-center text-white pointer-events-none">
                <div className="svg-container mr-2">
                  <SVG
                    onError={(error) => console.log(error.message)}
                    cacheRequests={true}
                    preProcessor={(code) =>
                      code.replace(/stroke=".*?"/g, 'stroke="currentColor"')
                    }
                    src={check}
                  />
                </div>
                <p className="text-nav-md font-nav-body">
                  {strings?.accountList?.first ? strings?.accountList?.first : 'Sync your game progress across platforms'}
                </p>
              </div>
              <div className="main-nav-account-element mb-4 flex items-center text-white">
                <div className="svg-container mr-2">
                  <SVG
                    onError={(error) => console.log(error.message)}
                    cacheRequests={true}
                    preProcessor={(code) =>
                      code.replace(/stroke=".*?"/g, 'stroke="currentColor"')
                    }
                    src={check}
                    className="mr-2"
                  />
                </div>

                <p className="text-nav-md font-nav-body">
                  {strings?.accountList?.second ? strings?.accountList?.second : 'Earn exclusive rewards'}
                </p>
              </div>
              <div className="main-nav-account-element flex items-center text-white">
                <div className="svg-container mr-2">
                  <SVG
                    onError={(error) => console.log(error.message)}
                    cacheRequests={true}
                    preProcessor={(code) =>
                      code.replace(/stroke=".*?"/g, 'stroke="currentColor"')
                    }
                    src={check}
                  />
                </div>
                <p className="text-nav-md font-nav-body">
                  {strings?.accountList?.third ? strings?.accountList?.third : 'Manage your preferences'}
                </p>
              </div>
              <div className="main-nav-account-buttons mt-10 flex flex-col lg:flex-row lg:space-x-4">
                <a
                  href="https://account.bhvr.com?sign-up"
                  target="_blank"
                  rel="noreferrer"
                  className="mb-4 bg-red lg:mb-0 relative main-nav-account-button"
                >
                  <span className="btn-text text-nav-md font-nav-bold uppercase z-10 pointer-events-none">
                    {strings?.signup ? strings?.signup : 'Sign up'}
                  </span>
                  <span className="hover-effect pointer-events-none"></span>
                </a>
                <a
                  href="https://account.bhvr.com?sign-in"
                  target="_blank"
                  rel="noreferrer"
                  className="border border-solid border-white bg-black relative main-nav-account-button"
                >
                  <span className="btn-text text-nav-md font-nav-bold uppercase z-10 pointer-events-none">
                    {strings?.signin ? strings?.signin : 'Sign in'}
                  </span>
                  <span className="hover-effect pointer-events-none"></span>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </nav>
  )
}

export default NavUtilsNew
